import { paymetPayload } from "interfaces";
import { post } from "services/services.methods";
import { PurchaseProvider } from "services/services.paths";

export const PaymentToProvider = (payload: paymetPayload) => {
  const response = post<any>(PurchaseProvider.paymentToProvider, payload);

  return response;
};
